<template>
  <div class="container-fluid">
        <div class="card card-default custom-card-height">
          <div class="card-header feature-header">
            <div class="row g-2">
              <div class="col-auto me-auto">
                <CardTitleComponent />
              </div>
              <div class="col-auto">
                <SearchComponent v-model="searchText" @search="onSearch" @clear="clearSearch" />
              </div>
              <div class="col-auto">
                <div class="row d-flex" :style="{ justifyContent: 'end' }">
                  <div :class="!isFortnox() ? 'col-md margin-bottom' : 'col-auto'">
                    <SubscriptionCommonComponent
                      v-if="isHost() && !isFortnox()"
                      @on-subscription="subscriptionChange"
                    />
                    <CompanyCommonComponent
                      v-if="isFortnox()"
                      @on-CompanyChange="onCompanyChange"
                    />
                    <div
                      v-else
                      class="input-group input-group-sm"
                      :style="{ width: '350px', float: 'right' }"
                    >
                      <div class="input-group-prepend">
                        <span class="input-group-text">{{ $t("company") }}</span>
                      </div>
                      <VueSelect
                        id="filter-by-company"
                        class="form-select"
                        :default-value="0"
                        :default-message="$t('all')"
                        v-model="companyId"
                        :items="
                          companies.map((c) => ({ id: c.id, text: c.name }))
                        "
                        :on-change="() => dataStateChange(initState())"
                      />
                    </div>
                  </div>
                  <div
                    class="col-auto btn-group margin-bottom"
                    role="group"
                    aria-label="Basic example"
                    v-if="!isFortnox()"
                  >
                    <a class="btn btn-outline-info btn-sm" @click="open()">
                      <i class="fas fa-plus me-1"></i>{{ $t("addNew") }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-body card-body-custom-layout">
            <div class="card-body-grid">
      
                <ejs-grid
                  ref="gridFinancialYear"
                  :dataSource="data"           
                  :allowPaging="true"
                  :autoFit="true"
                  :allowResizing="true"
                  :pageSettings="pageSettings"
                  :locale="locale"
                  :rowHeight="38"
                  height="100%"
                  :allowSorting="true"
                  :searchSettings="searchOptions"
                  :dataStateChange="dataStateChange"
                >
                  <e-columns>
                    <e-column
                      v-if="isFortnox()"
                      :headerText="$t('companyName')"
                      field="companyName" 
                      freeze="Left"
                      width="200"
                    ></e-column>
                    <e-column :headerText="$t('id')" field="Id"></e-column>
                    <e-column
                      :headerText="$t('fromDate')"
                      field="FromDate"
                      type="date"
                      format="yyyy-MM-dd"
                    ></e-column>
                    <e-column
                      :headerText="$t('toDate')"
                      field="ToDate"
                      type="date"
                      format="yyyy-MM-dd"
                    ></e-column>
                    <e-column
                      :headerText="$t('accountCharts')"
                      field="AccountCharts"
                    ></e-column>
                    <e-column
                      :headerText="$t('accountingMethod')"
                      field="AccountingMethod"
                    ></e-column>
                    <template v-if="!isFortnox()">
                      <e-column :headerText="$t('actions')" width="75" textAlign="Center" :template="'actionTemplate'">
                        <template v-slot:actionTemplate="{ data }">
                          <div class="btn-group actions-row" role="group" aria-label="Basic example">
                            <a href="javascript:void(0)" class="ms-2 action-link action-edit" title="Edit"
                              @click="commandClick('Edit', data)">
                              <i class="e-edit e-icons" style="font-size: 0.76em;"></i>
                            </a>
                            <a href="javascript:void(0)" class="ms-2 action-link action-delete" title="Delete"
                              @click="commandClick('Delete', data)">
                              <i class="e-delete e-icons" style="font-size: 0.76em;"></i>
                            </a>
                          </div>
                        </template>
                      </e-column>
                    </template>
                  </e-columns>
                </ejs-grid>
              </div>
              <ConfirmComponent :title="confirmTitle" @yes="commandConfirm()" />
            </div>
          </div>
          <!-- /.card-body -->
        </div>


  <div class="modal fade" id="financialyearModal" role="dialog">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ $t("financialYear") }}</h4>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
            @click="close()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form @submit.prevent="onUpsert">
          <div class="modal-body">
            <div class="form-row">
              <div class="col-md">
                <label
                  >{{ $t("company") }}<span class="text-danger">*</span></label
                >
                <VueSelect
                  id="add-fin-year"
                  class="form-select"
                  :default-value="0"
                  :default-message="$t('Select company')"
                  v-model="form.companyId"
                  :items="companies.map((c) => ({ id: c.id, text: c.name }))"
                />
              </div>
            </div>
            <div class="form-row mt-4">
              <div class="col-md">
                <div class="form-group">
                  <label
                    >{{ $t("fromDate")
                    }}<span class="text-danger">*</span></label
                  >
                  <EjsDatePicker
                    ref="datepicker_from_date"
                    required
                    format="yyyy-MM-dd"
                    v-model="form.fromDate"
                    :first-day-of-week="1"
                  />
                </div>
              </div>
              <div class="col-md">
                <div class="form-group">
                  <label
                    >{{ $t("toDate") }}
                    <span class="text-danger">*</span></label
                  >
                  <EjsDatePicker
                    ref="datepicker_to_date"
                    required
                    format="yyyy-MM-dd"
                    v-model="form.toDate"
                    :first-day-of-week="1"
                  />
                </div>
              </div>
            </div>
            <div class="form-row mt-4">
              <div class="col-md">
                <div class="form-group">
                  <label
                    >{{ $t("accountCharts") }} <span class="text-danger"></span
                  ></label>
                  <input
                    type="text"
                    class="form-control input-sm rounded-0"
                    v-model="form.accountCharts"
                  />
                </div>
              </div>
              <div class="col-md">
                <div class="form-group">
                  <label
                    >{{ $t("accountingMethod") }}
                    <span class="text-danger"></span
                  ></label>
                  <input
                    type="text"
                    class="form-control input-sm rounded-0"
                    v-model="form.accountingMethod"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-outline-danger" @click="close()">
              <i class="fas fa-times me-1"></i>{{ $t("close") }}
            </button>
            <button type="submit" class="btn btn-sm btn-outline-info">
              <i class="fas fa-save me-1"></i>{{ isUpdate ? $t("update") : $t("save") }}
            </button>
          </div>
        </form>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>
<script lang="ts">
import modal from "@/components/common/modalManage";
import staticMessage from "@/components/common/staticMessage";
import VueSelect from "@/components/common/VueSelect.vue";
import ConfirmComponent from "@/components/molecules/ConfirmComponent.vue";
import agent, { masterServiceBaseURL } from "@/services/agent";
import authService from "@/services/authService";
import preLoader from "@/services/preLoader";
import toasterService from "@/services/toasterService";
import { hasFortnox } from "@/shared/app.util";
import { L10n, setCulture } from "@syncfusion/ej2-base";
import { DatePickerComponent as EjsDatePicker } from "@syncfusion/ej2-vue-calendars";
import {
  ColumnDirective as EColumn,
  ColumnsDirective as EColumns,
  GridComponent as EjsGrid,
  Group,
  Page,
  Resize,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-vue-grids";
import axios from "axios";
import _ from "lodash";
import { defineComponent } from "vue";
import CompanyCommonComponent from "../../../fortnox/common/CompanyCommonComponent.vue";
import { Company } from "../Company/Company.model";
import SubscriptionCommonComponent from "../Subscription/SubscriptionCommonComponent.vue";
import {
  FinancialYear,
  FinancialYearGetResponse,
  Property,
} from "./FinancialYear.model";
import CardTitleComponent from "@/components/common/CardTitleComponent.vue";
import SearchComponent from "@/components/shared/SearchComponent.vue";

let _financialYearData: Property = {} as Property;
let _financialYearForm: FinancialYear = {} as FinancialYear;
let _companyList = [] as Company[];

export default defineComponent({
  components: {
    "ejs-grid": EjsGrid,
    "e-columns": EColumns,
    "e-column": EColumn,
    CompanyCommonComponent,
    ConfirmComponent,
    SubscriptionCommonComponent,
    EjsDatePicker,
    VueSelect,
    CardTitleComponent,
    SearchComponent,
  },
  provide: {
    grid: [Toolbar, Resize, Page, Sort, Group],
  },
  created() {
    agent.setBaseUrl(masterServiceBaseURL);

    this.gridLocalize();
  },
  data() {
    return {
      data: _financialYearData,
      form: _financialYearForm,
      isUpdate: false,
      subscriptionId: "",
      isTableLoad: false,
      confirmTitle: "",
      confirmIsDelete: false,
      selectedState: null,
      companyId: 0,
      companies: _companyList,
      searchOptions: {
        fields: [
          "AccountCharts",
          "AccountingMethod",
          "Id",
          "FromDate",
          "ToDate",
        ],
        operator: "contains",
        ignoreCase: true,
      },
      toolbar: ["Search"],
      pageSettings: {
        pageSizes: [10, 20, 50, 100],
        pageSize: 50,
        pageCount: 5,
      },
      locale: "",
      gridLocal: {
        "se-grid": {
          grid: {
            EmptyRecord: "Inga poster visas",
            Search: "Sök",
            GroupDropArea:
              "Dra en kolumnrubrik hit för att gruppera din kolumn",
            UnGroup: "Klicka här för att avgruppera",
            EmptyDataPageError:
              "DataPage får inte vara tom vid den första laddningen eftersom kolumner från dataPage finns i AutoGenerate Column Grid",
            Item: "Artikel",
            Items: "Artikel",
          },
          pager: {
            currentPageInfo: "{0} av {1} sidor",
            totalItemsInfo: "({0} inlägg)",
            firstPageTooltip: "Till första sidan",
            lastPageTooltip: "Till sista sidan",
            nextPageTooltip: "Till nästa sida",
            previousPageTooltip: "Tillbaka till sista sidan",
            nextPagerTooltip: "Till nästa personsökare",
            previousPagerTooltip: "Gå till föregående personsökare",
            pagerDropDown: "Objekt per sida",
          },
        },
      },
      searchText: "",
    };
  },
  mounted() {
    this.dataStateChange(this.initState());
  },
  methods: {
    initState(): any {
      let state = {
        skip: 0,
        take: this.pageSettings.pageSize,
      };
      return state;
    },
    dataStateChange(state: any) {
      this.gridLocalize();
      this.loadFinancialYear(state);
    },
    loadFinancialYear(state: any) {
      if (state.action) {
        delete state.action;
      }

      const gridFinancialYear: any = this.$refs.gridFinancialYear;
      if (gridFinancialYear) gridFinancialYear.hideSpinner();

      const companyId = this.companyId;
      let urlBase: string = authService.getModulesBaseUrl()!.fortnox;

      if (hasFortnox()) {
        preLoader.show();
        axios
          .post(
            `${urlBase}v1/financialYear/getfinancialYear`,
            { ...state, companyId },
            {
              headers: { Authorization: `Bearer ${authService.getToken()}` },
            }
          )
          .then((response) => {
            if (response) {
              preLoader.hide();
              let financialYears: FinancialYear[] = [];
              _.map(response.data.result.result, (item) => {
                let financialYear: FinancialYear = {
                  id: item.id,
                  accountCharts: item.accountCharts,
                  accountingMethod: item.accountingMethod,
                  companyName: item.companyName,
                  companyId: item.companyId,
                  fromDate: item.fromDate,
                  toDate: item.toDate,
                  createdBy: "",
                  modifiedBy: "",
                };
                financialYears.push(financialYear);
              });
              this.data = {
                result: financialYears,
                count: financialYears.length,
              };
            }
          })
          .catch(() => {});
      } else {
        console.log("cid: ", this.companyId);
        const subscriptionId = this.subscriptionId;
        agent
          .post<FinancialYearGetResponse>(`v1/financialYear/getfinancialYear`, {
            ...state,
            subscriptionId,
            companyId,
          })
          .then((response) => {
            if (response.result) {
              this.data = response.result;
            }
          })
          .catch(() => {});
      }
    },
    commandClick: function (type: string, data: FinancialYear) {
      this.isUpdate = false;
      switch (type) {
        case "Delete":
          this.confirmTitle = this.$t("msgSureWantToDelete");
          this.form.id = data.id;
          this.confirmIsDelete = true;
          break;
        case "Edit":
          this.form = data;
          this.isUpdate = true;
            modal.Open("financialyearModal");
            break;
          default:
            break;
        }
    },
    open() {
      this.form = { companyId: 0 } as FinancialYear;
      this.isUpdate = false;
      modal.Open("financialyearModal");
    },
    close() {
      this.form = {} as FinancialYear;
      // this.form.fromDate = null;
      // this.form.toDate = null;

      (this.$refs.datepicker_from_date as any)?.ej2Instances?.clear();
      (this.$refs.datepicker_to_date as any)?.ej2Instances?.clear();

      modal.Close("financialyearModal");
    },
    subscriptionChange(subscriptionId: string) {
      this.subscriptionId = subscriptionId;
      if (subscriptionId.trim().toLowerCase().indexOf("all") > -1) {
        this.subscriptionId = "";
      }

      this.loadFinancialYear(this.initState());
    },
    onUpsert() {
      console.log("dates: ", this.form.fromDate);

      if (this.isUpdate) {
        this.onEdit();
      } else {
        this.onSave();
      }
    },
    onSave() {
      let post = { ...this.form };
      post.createdBy = authService.getUserEmail();

      agent
        .post<FinancialYearGetResponse>(`v1/financialyear`, post)
        .then((response) => {
          if (response.result) {
            toasterService.success(this.$t("msgSave"));
            this.loadFinancialYear(this.initState());
            this.resetFinancialYear();
            this.close();
          }
        })
        .catch(() => {});
    },
    onEdit() {
      let put = { ...this.form };
      put.modifiedBy = authService.getUserEmail();

      agent
        .put<FinancialYearGetResponse>(`v1/financialyear`, put)
        .then((response) => {
          if (response.result) {
            toasterService.success(this.$t("msgUpdate"));
            this.loadFinancialYear(this.initState());
            this.resetFinancialYear();
            this.close();
          }
        })
        .catch(() => {});
    },
    onDelete() {
      let put = { ...this.form };

      agent
        .delete<FinancialYearGetResponse>(`v1/financialyear/${put.id}`)
        .then((response) => {
          if (response.result) {
            toasterService.success(this.$t("msgDelete"));
            this.loadFinancialYear(this.initState());
            this.resetFinancialYear();
          }
        })
        .catch(() => {});
    },
    resetFinancialYear() {
      this.form = {} as FinancialYear;
      this.isUpdate = false;
    },
    commandConfirm() {
      if (this.confirmIsDelete) {
        this.onDelete();
        this.confirmIsDelete = false;
      }
    },
    onCompanyChange(companyId: number) {
      this.companyId = companyId;
      this.loadFinancialYear(this.initState());
    },
    isFortnox() {
      return hasFortnox();
    },
    isHost() {
      return authService.isHost();
    },
    gridLocalize() {
      this.locale = "en-grid";
      if (this.$i18n.locale == "se") {
        setTimeout(() => {
          this.locale = "se-grid";
          setCulture("se-grid");
          L10n.load({
            ...this.gridLocal,
          });
        });
      }
    },
    onSearch(searchText: string) {
      const grid = (this.$refs.gridFinancialYear as any)?.ej2Instances;
      if (grid) grid.search(searchText);
    },
    clearSearch() {
      this.searchText = '';
      const grid = (this.$refs.gridFinancialYear as any)?.ej2Instances;
      if (grid) grid.search('');
    }
  },
});
</script>
@/services/authService
